// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"jhgT1":[function(require,module,exports) {
var _three = require("three");
var _groundedSkyboxJs = require("three/examples/jsm/objects/GroundedSkybox.js");
var _gltfloaderJs = require("three/examples/jsm/loaders/GLTFLoader.js");
var _rgbeloaderJs = require("three/examples/jsm/loaders/RGBELoader.js");
var _scriptsJs = require("./scripts.js");
// environment set up
let envMap;
const params = {
    height: 15,
    radius: 100,
    enabled: true
};
let skybox;
// load snow/beach env 
function loadEnvironmentMap(path) {
    new (0, _rgbeloaderJs.RGBELoader)().load(path, (hdrMap)=>{
        hdrMap.mapping = _three.EquirectangularReflectionMapping;
        envMap = hdrMap;
        if (skybox) (0, _scriptsJs.scene).remove(skybox);
        skybox = new (0, _groundedSkyboxJs.GroundedSkybox)(envMap, params.height, params.radius);
        skybox.position.y = params.height - 0.01;
        (0, _scriptsJs.scene).add(skybox);
        (0, _scriptsJs.scene).environment = envMap;
        (0, _scriptsJs.scene).background = null;
    });
    if (floor) {
        (0, _scriptsJs.scene).remove(floor);
        floor.geometry.dispose();
        floor.material.dispose();
        floor = null;
    }
}
function loadStudiotMap() {
    (0, _scriptsJs.scene).environment = null;
    (0, _scriptsJs.scene).background = null;
    const SCENE_COLOR = 0x000000;
    (0, _scriptsJs.scene).background = new _three.Color(SCENE_COLOR);
    if (skybox) (0, _scriptsJs.scene).remove(skybox);
    new (0, _rgbeloaderJs.RGBELoader)().load("./assets/studio/studio_small_08_1k.hdr", (hdrMap)=>{
        hdrMap.mapping = _three.EquirectangularReflectionMapping;
        envMap = hdrMap;
        (0, _scriptsJs.scene).background = new _three.Color(0x000000);
        (0, _scriptsJs.scene).environment = envMap;
    });
}
// default to be studio env
loadStudiotMap();
document.getElementById("snow").addEventListener("click", ()=>{
    loadEnvironmentMap("./assets/snow/birchwood_1k.hdr");
    document.getElementById("studio").classList.remove("show");
});
document.getElementById("beach").addEventListener("click", ()=>{
    loadEnvironmentMap("./assets/sunrise/blouberg_sunrise_2_1k.hdr");
    document.getElementById("studio").classList.remove("show");
});
document.getElementById("studioButton").addEventListener("click", ()=>{
    loadStudiotMap();
    document.getElementById("studio").classList.add("show");
});
document.getElementById("defaultLight").addEventListener("click", function() {
    loadStudiotMap();
});
document.getElementById("customLight").addEventListener("click", function() {
    (0, _scriptsJs.scene).environment = null;
    (0, _scriptsJs.scene).background = new _three.Color(0x000000);
});
// floor
let floor;
function addAsphaltFloor() {
    // Load the floor texture
    const textureLoader = new _three.TextureLoader();
    // Load the textures
    const colorTexture = textureLoader.load("./assets/asphalt/Asphalt025C_2K-JPG_Color.jpg");
    const displacementTexture = textureLoader.load("./assets/asphalt/Asphalt025C_2K-JPG_Displacement.jpg");
    const normalTexture = textureLoader.load("./assets/asphalt/Asphalt025C_2K-JPG_NormalGL.jpg");
    const roughnessTexture = textureLoader.load("./assets/asphalt/Asphalt025C_2K-JPG_Roughness.jpg");
    const aoTexture = textureLoader.load("./assets/asphalt/Asphalt025C_2K-JPG_AmbientOcclusion.jpg");
    // Set texture parameters
    colorTexture.wrapS = colorTexture.wrapT = _three.RepeatWrapping;
    displacementTexture.wrapS = displacementTexture.wrapT = _three.RepeatWrapping;
    normalTexture.wrapS = normalTexture.wrapT = _three.RepeatWrapping;
    aoTexture.wrapS = aoTexture.wrapT = _three.RepeatWrapping;
    // Create the floor plane
    let floorGeometry = new _three.PlaneGeometry(20, 20);
    let floorMaterial = new _three.MeshStandardMaterial({
        map: colorTexture,
        displacementMap: displacementTexture,
        normalMap: normalTexture,
        roughnessMap: roughnessTexture,
        aoMap: aoTexture,
        displacementScale: 0,
        side: _three.DoubleSide
    });
    floor = new _three.Mesh(floorGeometry, floorMaterial);
    floor.rotation.x = -Math.PI / 2; // Rotate to lay flat
    floor.position.y = 0;
    (0, _scriptsJs.scene).add(floor);
}
function addConcreteFloor() {
    // Load the floor texture
    const textureLoader = new _three.TextureLoader();
    // Load the textures
    const colorTexture = textureLoader.load("./assets/concrete/Concrete017_1K-PNG_Color.png");
    const displacementTexture = textureLoader.load("./assets/concrete/Concrete017_1K-PNG_Displacement.png");
    const normalTexture = textureLoader.load("./assets/concrete/Concrete017_1K-PNG_NormalGL.png");
    const roughnessTexture = textureLoader.load("./assets/concrete/Concrete017_1K-PNG_Roughness.png");
    // const aoTexture = textureLoader.load("./assets/asphalt/Asphalt025C_2K-JPG_AmbientOcclusion.jpg");
    // Set texture parameters
    colorTexture.wrapS = colorTexture.wrapT = _three.RepeatWrapping;
    displacementTexture.wrapS = displacementTexture.wrapT = _three.RepeatWrapping;
    normalTexture.wrapS = normalTexture.wrapT = _three.RepeatWrapping;
    // aoTexture.wrapS = aoTexture.wrapT = THREE.RepeatWrapping;
    // Create the floor plane
    let floorGeometry = new _three.PlaneGeometry(20, 20);
    let floorMaterial = new _three.MeshStandardMaterial({
        map: colorTexture,
        displacementMap: displacementTexture,
        normalMap: normalTexture,
        roughnessMap: roughnessTexture,
        //   aoMap: aoTexture,
        displacementScale: 0,
        side: _three.DoubleSide
    });
    floor = new _three.Mesh(floorGeometry, floorMaterial);
    floor.rotation.x = -Math.PI / 2; // Rotate to lay flat
    floor.position.y = 0;
    (0, _scriptsJs.scene).add(floor);
}
document.getElementById("floorDropdown").addEventListener("change", function() {
    var selectedOption = this.value;
    if (selectedOption === "asphalt") addAsphaltFloor();
    else if (selectedOption === "concrete") addConcreteFloor();
});

},{"three":"35GVu","three/examples/jsm/objects/GroundedSkybox.js":"llUyU","three/examples/jsm/loaders/GLTFLoader.js":"d9kK2","three/examples/jsm/loaders/RGBELoader.js":"1pJcd","./scripts.js":"f5JPT"}]},["jhgT1"], "jhgT1", "parcelRequire6fcf")

//# sourceMappingURL=index.24f97a4f.js.map
